export const SUPPORTED_CURRENCIES = ["MAD", "EUR", "USD", "CAD", "GBP", "AED"] as const;

export type CurrencyCode = (typeof SUPPORTED_CURRENCIES)[number];

export const DEFAULT_CURRENCY: CurrencyCode = "MAD";

export const CURRENCY_STORAGE_KEY = "rakb_display_currency";
export const EXCHANGE_RATES_STORAGE_KEY = "rakb_exchange_rates";
export const EXCHANGE_RATES_TTL_MS = 6 * 60 * 60 * 1000;

export const COUNTRY_TO_CURRENCY: Record<string, CurrencyCode> = {
  MA: "MAD",
  FR: "EUR",
  ES: "EUR",
  BE: "EUR",
  DE: "EUR",
  CA: "CAD",
  GB: "GBP",
  US: "USD",
  AE: "AED",
};

export const TIMEZONE_TO_CURRENCY: Record<string, CurrencyCode> = {
  "Africa/Casablanca": "MAD",
  "Europe/Paris": "EUR",
  "Europe/Madrid": "EUR",
  "Europe/Brussels": "EUR",
  "Europe/Berlin": "EUR",
  "America/Toronto": "CAD",
  "America/Vancouver": "CAD",
  "Europe/London": "GBP",
  "America/New_York": "USD",
  "America/Los_Angeles": "USD",
  "Asia/Dubai": "AED",
};

export const CURRENCY_LABELS: Record<CurrencyCode, string> = {
  MAD: "MAD",
  EUR: "EUR",
  USD: "USD",
  CAD: "CAD",
  GBP: "GBP",
  AED: "AED",
};
